import React from 'react';
import ReactDOM from 'react-dom';

import CloseIcon from '@swf/core/assets/icons/close.svg';
import { canUseDOM } from '@swf/core/utils';
import { useHomeGamesWidget, useOpenGame, useWpGameUrl } from '@swf/poker';

import styles from './WebPokerGame.scss';

interface WebPokerGameProps {
  serverAddress: string;
  serverObjectName: string;
  type: string;
  onClose?: () => void;
  newTab?: boolean;
  id: string;
}

type Handler = (e: React.MouseEvent<Element, MouseEvent> | MessageEvent) => void;

const WebPokerGame: React.FC<WebPokerGameProps> = ({
  serverAddress,
  serverObjectName,
  type,
  newTab,
  onClose,
  id
}) => {
  const { widgetDispatch } = useHomeGamesWidget();
  const { url } = useWpGameUrl({ type, serverAddress, serverObjectName, newTab, onClose });
  const handleClose: Handler = (e) => {
    e.stopPropagation();

    widgetDispatch.leaveGame(id);

    if (onClose) {
      onClose();
    }
  };
  useOpenGame(handleClose);

  return !newTab && canUseDOM && url
    ? ReactDOM.createPortal(
        <>
          <div className={styles.backdrop} />
          <div className={styles.gameWrapper}>
            <div className={styles.game}>
              <button className={styles.close} onClick={handleClose}>
                <CloseIcon />
              </button>
              <iframe
                allowFullScreen
                allow="microphone; camera"
                className={styles.gameIframe}
                src={url}
                title="Web Poker"
              />
            </div>
          </div>
        </>,
        document.getElementById('root') as HTMLElement
      )
    : null;
};

export default WebPokerGame;
